import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import useMediaQuery from "../../hooks/useMediaQuery";

const ReadMore = ({
  children,
  classList = "",
  buttonClassList = "",
  buttonText = "Read More",
  buttonCallback = () => {},
  showMobileOnly = true,
  initialHeight = "100",
  parentScrollRef = false
}) => {
  const [maxHeight, setMaxHeight] = useState(initialHeight);
  const [hideReadMore, setHideReadMore] = useState(false);
  const [readMoreStyles, setReadMoreStyles] = useState({ maxHeight: `${initialHeight}px` });
  const [isOpen, setIsOpen] = useState(false);
  const { deviceScreen } = useMediaQuery();
  const smallScreen = ["x-small", "small"].includes(deviceScreen);
  const readMoreContainer = useRef();

  useEffect(() => {
    if (!smallScreen && showMobileOnly) {
      setHideReadMore(true);
      setReadMoreStyles({});
    } else {
      setHideReadMore(initialHeight >= calculatedHeight());
      setReadMoreStyles({
        maxHeight: isOpen ? `${maxHeight}px` : `${initialHeight}px`
      });
    }
  }, [smallScreen, maxHeight]);

  const calculatedHeight = () => {
    //calculate height of all the children!
    let children = [...readMoreContainer.current.children];
    let height = 0;
    children.forEach((child) => (height += child.offsetHeight));
    return height;
  };

  const toggleReadMore = (e) => {
    e.preventDefault();

    setIsOpen(!isOpen);
    setMaxHeight(isOpen ? initialHeight : calculatedHeight());
    if (isOpen && smallScreen) {
      parentScrollRef
        ? parentScrollRef.current.scrollIntoView()
        : readMoreContainer.current.scrollIntoView();
    }

    buttonCallback();
  };

  return (
    <div
      className={`read-more__container ${classList} ${isOpen ? "read-more--is-open" : ""}`}
      data-testid="read-more-wrapper"
    >
      <div className="read-more__content" ref={readMoreContainer} style={readMoreStyles}>
        {children}

        <div
          className="read-more__gradient"
          style={{
            opacity: isOpen ? 0 : 1
          }}
        ></div>
      </div>
      {!hideReadMore && (
        <div className={`read-more__button-wrapper ${buttonClassList}`} onClick={toggleReadMore}>
          <a type="button" className={`btn btn-text btn-text-blue ${buttonClassList}`}>
            {!isOpen ? buttonText : "Read Less"}
          </a>
        </div>
      )}
    </div>
  );
};

ReadMore.propTypes = {
  buttonCallback: PropTypes.func,
  buttonText: PropTypes.string,
  children: PropTypes.node.isRequired,
  classList: PropTypes.string,
  id: PropTypes.string,
  initialHeight: PropTypes.number,
  parentScrollRef: PropTypes.object,
  showMobileOnly: PropTypes.bool
};

export default ReadMore;
